(function () {
    'use strict';

    const selectors = document.querySelectorAll('.selector');

    if (selectors) {
        selectors.forEach((selector) => {
            const wrapper = selector.querySelector('.selector-wrapper');
            const toggleButton = wrapper?.querySelector('button');
            const submenu = selector.querySelector('.selector-sub');
            const submenuLinks = submenu?.querySelectorAll('a') || [];
            let timeout;

            const setSubmenuAccessibility = (visible) => {
                if (!submenu) return;
                submenu.setAttribute('aria-hidden', !visible);
                submenuLinks.forEach(link => {
                    if (visible) {
                        link.removeAttribute('tabindex');
                    } else {
                        link.setAttribute('tabindex', '-1');
                    }
                });
            };

            const openMenu = () => {
                clearTimeout(timeout);
                selector.classList.remove('selector-closed');
                selector.classList.add('selector-active');
                setSubmenuAccessibility(true);

                if (submenu && submenuLinks.length) {
                    submenu.style.width = 'auto';
                    submenu.classList.add('w-auto');

                    const widths = Array.from(submenuLinks).map(link => link.offsetWidth);
                    const maxWidth = Math.max(...widths) + 18 + 'px';
                    submenu.style.width = maxWidth;
                }
            };

            const closeMenu = () => {
                timeout = setTimeout(() => {
                    selector.classList.remove('selector-active');
                    selector.classList.add('selector-closed');
                    setSubmenuAccessibility(false);
                }, 150);
            };

            // Hover
            if (wrapper) {
                wrapper.addEventListener('mouseenter', openMenu);
                wrapper.addEventListener('mouseleave', closeMenu);
            }

            if (submenu) {
                submenu.addEventListener('mouseenter', openMenu);
                submenu.addEventListener('mouseleave', closeMenu);
            }

            // Keyboard toggle via button only
            if (toggleButton) {
                toggleButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    const isActive = selector.classList.contains('selector-active');
                    if (isActive) {
                        closeMenu();
                    } else {
                        openMenu();
                    }
                });

                toggleButton.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
                        e.preventDefault();
                        openMenu();
                        submenuLinks[0]?.focus();
                    }
                });
            }

            // Focusout auto-close
            selector.addEventListener('focusout', () => {
                timeout = setTimeout(() => {
                    if (!selector.contains(document.activeElement)) {
                        closeMenu();
                    }
                }, 150);
            });

            // Init: hide submenu from screen readers and tab order
            setSubmenuAccessibility(false);
        });
    }
})();
